<!-- 商品主数据新增 -->
<template>
  <div class="addGoods">
    <!-- 按钮 -->
    <div class="btn">
      <el-button
        v-hasPermi="['2021050815440366025']"
        type="primary"
        :disabled="
          goodsDetail.parentProductStatus == 'ZT01' ||
          goodsDetail.parentProductStatus == 'ZT02' ||
          goodsDetail.parentProductStatus == 'ZT04'
        "
        @click="modify"
        >{{ this.$t('goods.button.modify') }}</el-button
      >
    </div>
    <!-- <div class="topForm" v-if="$route.name == 'editGoods'">
      <el-form :model="editData" ref="topForm" label-width="90px" :rules="rules">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="修改原因" prop="editReason">
              <el-input v-model="editData.editReason" clearable maxlength="80"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div> -->
    <!-- tab页 -->
    <el-tabs class="addGoodsTabs" type="border-card">
      <!-- 物产化工主数据 -->
      <el-tab-pane :label="$t('goods.tab.wchgData')">
        <wchg-data
          ref="wchgData"
          :addFlag="false"
          :isEdit="true"
          :goodsDetail="goodsDetail"
          :extendList="extendList"
          v-if="goodsDetail"
          v-on:changeText="success"
          v-on:changeTableRow="changeTableRow"
          v-on:changeAuth="changeAuth"
          v-on:changeCompany="changeCompany"
          :addedTaxRateOptions="dictList.addedTaxRateOptions"
        />
      </el-tab-pane>
      <!-- 公司自有数据 -->
      <el-tab-pane :label="$t('goods.tab.companyData')">
        <company-data
          ref="companyData"
          :isEdit="true"
          :extendList="extendList"
          :goodsDetail="goodsDetail"
          :firstTabData="firstTabData"
          v-if="goodsDetail"
        />
      </el-tab-pane>
      <!-- 系统映射表 -->
      <el-tab-pane :label="$t('goods.tab.mappingData')">
        <mapping-data
          ref="mappingData"
          :isEdit="true"
          :dataMapping="goodsDetail.systemMaps || []"
          :callLogsData="goodsDetail.callLogs || []"
          v-if="goodsDetail"
        />
      </el-tab-pane>
      <!-- 历史记录 -->
      <el-tab-pane :label="$t('goods.tab.historyData')">
        <history-data
          ref="historyData"
          :dataHistories="goodsDetail.dataHistories"
          v-if="goodsDetail"
        />
      </el-tab-pane>
    </el-tabs>
    <!-- 底部按钮 -->
    <div style="margin-top: 10px">
      <footer class="fixed-bottom-btnList" v-if="$route.name == 'editGoods'">
        <!-- <el-button
          v-hasPermi="['2021050815440366025']"
          type="primary"
          :disabled="
            goodsDetail.parentProductStatus == 'ZT01' ||
            goodsDetail.parentProductStatus == 'ZT02' ||
            goodsDetail.parentProductStatus == 'ZT04'
          "
          @click="modify"
          >{{ this.$t('goods.button.modify') }}</el-button
        > -->
        <el-button
          class="fixed-bottom-btn"
          type="primary"
          v-if="goodsDetail.parentProductStatus != 'ZT03'"
          :loading="loading"
          @click="save(0)"
          >{{ this.$t('goods.button.save') }}</el-button
        >
        <el-button type="primary" class="fixed-bottom-btn" :loading="loading" @click="save(1)">{{
          this.$t('goods.button.sureSave')
        }}</el-button>
        <el-button type="info" plain @click="save(2)">返回</el-button>
      </footer>
      <footer class="fixed-bottom-btnList" v-else>
        <el-button type="primary" class="fixed-bottom-btn" :loading="loading" @click="save(0)">{{
          this.$t('goods.button.save')
        }}</el-button>
        <el-button class="fixed-bottom-btn" type="primary" :loading="loading" @click="save(1)">{{
          this.$t('goods.button.submit')
        }}</el-button>
      </footer>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import wchgData from './components/wchgData'; // 物产化工主数据
  import companyData from './components/companyData'; // 公司自有数据
  import mappingData from './components/mappingData'; // 系统映射表
  import historyData from './components/historyData'; // 历史记录表
  import API from '@/api/masterData/goods';
  import XEUtils from 'xe-utils';

  export default {
    name: 'editGoods',
    components: {
      wchgData,
      companyData,
      mappingData,
      historyData,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
        dictList: (state) => {
          console.log(state, '--------------------');
          let obj = {
            unitOptions: state.dict.dictListMap['basic_unit'] || [],
            incomeCourseOptions: state.dict.dictListMap['income_course'] || [],
            costCourseOptions: state.dict.dictListMap['cost_course'] || [],
            addedTaxRateOptions: state.dict.dictListMap['tax_rate'] || [],
          };
          return obj;
        },
      }),
      propsGoodsId() {
        // 获取路由参数 => 合作伙伴详情
        return this.$route.query.propsGoodsId;
      },
    },
    watch: {},
    created() {
      this.getDetail();
      //this.getCompanyInfo()//获取公司信息
    },
    data() {
      return {
        loading: false,
        goodsDetail: {},
        firstTabData: {
          dataAuthTableData: [],
          baseData: {},
        },
        extendList: [], //扩展公司信息 同时也是数据权限
        companyOptions: [], //公司下拉
        /* dictList: {
        unitOptions: [],
        groupCategoryOptions: [],
        incomeCourseOptions: [],
        costCourseOptions: [],
        addedTaxRateOptions: []
      },//所有数据字典结果 */
        editData: {
          editReason: '',
        },
        rules: {
          editReason: [
            {
              required: true,
              message: this.$t('warehouseContract.form.editResonPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
        },
      };
    },
    mounted() {},
    methods: {
      //获取数据权限表格数据
      getCompanyInfo() {
        //判断是否是新增
        if (this.$route.name == 'addGoods') {
          //新增
          let extendList = [];
          let obj = {
            extendCompanyCode: this.userInfo.companyCode,
            extendCompanyName: this.userInfo.companyName,
            list: [],
          };
          extendList.push(obj);
          this.extendList = extendList;
        } else {
          this.extendList = this.goodsDetail.extendList;
        }
      },
      // 获取商品主数据详情
      getDetail() {
        const params = {
          id: this.propsGoodsId,
          // productDetailCode: this.$route.query.productDetailCode
        };
        this.$axios
          .post(API.PRODUCT_DETAIL, params)
          .then((res) => {
            if (res.data.code === 0) {
              this.goodsDetail = res.data.data;
              if (this.goodsDetail.customs) {
                delete this.goodsDetail.customs.gmtCreate;
                delete this.goodsDetail.customs.companyCode;
              }
              this.firstTabData.baseData.basicUnit = this.goodsDetail.basicUnit;
              this.extendList = this.goodsDetail.extendList;
              //this.$refs.companyData.reloadData(this.goodsDetail.extendList);
              //this.getCompanyInfo();
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          })
          .then(() => {
            this.$refs.wchgData.clearValidate();
          });
      },
      save(value) {
        if (value === 0) {
          //保存
          this.sureSave(value);
        } else if (value === 1) {
          //提交
          if (this.$route.name == 'editGoods') {
            Promise.resolve(this.$refs.wchgData.validateAll()).then((res) => {
              if (res) {
                this.sureSave(value);
              }
            });
            // this.$refs.topForm.validate((valid) => {
            //   if (valid) {
            //     Promise.resolve(this.$refs.wchgData.validateAll()).then((res) => {
            //       if (res) {
            //         this.sureSave(value);
            //       }
            //     });
            //   }
            // });
          } else {
            Promise.resolve(this.$refs.wchgData.validateAll()).then((res) => {
              if (res) {
                this.sureSave(value);
              }
            });
          }
        } else {
          // this.$router.go(-1);
          let path = {
            path: '/masterData/goods',
            name: 'goods',
            meta: {
              keepAlive: true,
              title: '商品主数据',
            },
          };
          this.$nextTick(() => {
            this.$router.push(path);
          });
        }
      },

      //确认修改
      async sureSave(value) {
        this.firstTabData = this.$refs.wchgData.exportChildData();
        let taxRate = '';
        let valueAddedTaxRateValue = {};
        taxRate = this.firstTabData.baseData.valueAddedTaxCode;
        valueAddedTaxRateValue =
          this.dictList.addedTaxRateOptions.find((i) => i.value == taxRate) || {};
        this.firstTabData.baseData.valueAddedTaxRate = valueAddedTaxRateValue.taxRate || '';
        this.firstTabData.baseData.valueAddedTaxCode = valueAddedTaxRateValue.value || '';
        this.extendList = this.$refs.companyData.exportChildData().map((item) => {
          return {
            ...item,
            list:
              item?.list.map((it) => {
                return {
                  ...it,
                  purchaseOrderUnit: it.purchaseOrderUnit
                    ? it.purchaseOrderUnit
                    : this.firstTabData.baseData.basicUnit,
                  salesOrderUnit: it.salesOrderUnit
                    ? it.salesOrderUnit
                    : this.firstTabData.baseData.basicUnit,
                };
              }) || [],
          };
        });
        console.log(this.firstTabData.baseData.basicUnit, '???编辑', this.extendList);
        const {
          parentProductNo,
          tenantCode,
          companyCode,
          departmentCode,
          departmentName,
          requestPerson,
          productChName,
          productSearchCode,
          productEnName,
          groupCategory,
          groupCategoryName,
          basicUnit,
          valueAddedTaxRate,
          valueAddedTaxCode,
          customsId,
          salesTaxRate,
          salesTaxCode,
        } = this.firstTabData.baseData;
        let extendList = JSON.parse(JSON.stringify(this.extendList));
        extendList.map((item) => {
          item.list = JSON.stringify(item.list);
        });
        let permissions = [];
        this.firstTabData.dataAuthTableData.map((item, index) => {
          const permissionDepartmentCode = item.permissionDepartmentCode
            ? item.permissionDepartmentCode.toString()
            : '';
          permissions.push({
            permissionCompanyCode: item.extendCompanyCode,
            permissionCompanyName:
              item.extendCompanyName || this.extendList[index].extendCompanyName,
            dataStatus: item.dataStatus,
            id: item.id,
            permissionDepartmentCode,
            permissionDepartmentName: item.permissionDepartmentName,
          });
        });
        this.firstTabData.goodsTableData.map((item) => {
          item.detailProductDisplayName = `${item.detailProductDisplayName}-${item.detailProductItems}-${item.detailProductVendor}-${item.detailProductOriginalPlace}-${item.detailProductModel}-${item.detailProductPack}-${item.detailProductMaterial}`;
        });
        const params = {
          parentProductNo,
          tenantCode,
          companyCode,
          departmentCode,
          departmentName,
          requestPerson,
          productChName,
          productSearchCode,
          productEnName,
          groupCategory,
          groupCategoryName,
          basicUnit,
          valueAddedTaxRate,
          valueAddedTaxCode,
          salesTaxRate,
          salesTaxCode,
          customsId,
          id: this.goodsDetail.id,
          version: this.goodsDetail.version,
          productDetails: JSON.stringify(this.firstTabData.goodsTableData),
          extendList: JSON.stringify(extendList),
          permissions: JSON.stringify(permissions),
          ids: JSON.stringify(this.firstTabData.ids),
          operateFlag: value,
          adminFlag: this.userInfo.userInfo.adminFlag,
          companyName: this.goodsDetail.companyName,
        };
        const testFlag = await this.linkText(productChName);
        if (testFlag) {
          return this.$message({
            type: 'warning',
            message: '商品名称重复，请勿提交',
          });
        }
        this.loading = true;
        this.$axios.post(API.PRODUCT_UPDATE, params).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            if (value == 0) {
              this.getDetail();
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
            } else {
              this.returnPath();
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },

      async linkText(va) {
        let flag = false;
        const params = {
          productChName: va,
          id: (this.goodsDetail || {}).id || '',
        };
        await this.$axios.post(API.CHECK_PRODUCT_DISPLAY_NAME, params).then((res) => {
          if (res.data.code === 10000) {
            flag = true;
          } else {
            flag = false;
          }
        });
        return flag;
      },

      //获取页面值返回给后台
      getPageParam(value) {
        this.firstTabData = this.$refs.wchgData.exportChildData();
        this.extendList = this.$refs.companyData.exportChildData();
        const {
          parentProductNo,
          tenantCode,
          companyCode,
          departmentCode,
          departmentName,
          requestPerson,
          productChName,
          productSearchCode,
          productEnName,
          groupCategory,
          basicUnit,
          valueAddedTaxRate,
          customsId,
        } = this.firstTabData.baseData;
        let extendList = JSON.parse(JSON.stringify(this.extendList));
        extendList.map((item) => {
          item.list = JSON.stringify(item.list);
        });
        let permissions = [];
        this.firstTabData.dataAuthTableData.map((item) => {
          permissions.push({
            permissionCompanyCode: item.extendCompanyCode,
            permissionCompanyName: item.extendCompanyName,
            dataStatus: item.dataStatus,
            id: item.id,
          });
        });
        const params = {
          parentProductNo,
          tenantCode,
          companyCode,
          departmentCode,
          departmentName,
          requestPerson,
          productChName,
          productSearchCode,
          productEnName,
          groupCategory,
          basicUnit,
          valueAddedTaxRate,
          // salesTaxRate,
          // salesTaxCode,
          customsId,
          id: this.goodsDetail.id,
          version: this.goodsDetail.version,
          productDetails: JSON.stringify(this.firstTabData.goodsTableData),
          extendList: JSON.stringify(extendList),
          permissions: JSON.stringify(permissions),
          ids: JSON.stringify(this.firstTabData.ids),
          operateFlag: value,
          adminFlag: this.userInfo.userInfo.adminFlag,
          companyName: this.goodsDetail.companyName,
        };
        return params;
      },

      // 返回列表页
      returnPath() {
        let path = {
          fromPath: {
            path: '/masterData/editGoods',
            name: 'editGoods',
            meta: {
              keepAlive: true,
              title: '修改商品主数据',
            },
          },
          toPath: {
            path: '/masterData/goods',
            name: 'goods',
            meta: {
              keepAlive: false,
              title: '商品主数据',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //禁用
      forbiden() {},

      //单元格数据变化 还有中文名称基本单位等下拉变化的时候 改变扩展list
      success(value1, value2, arr) {
        this.firstTabData.baseData.basicUnit = value2;
        this.extendList.map((item) => {
          if (arr.length >= 1) {
            item.list.map((item2, index) => {
              item2.detailProductDisplayName = arr[index].detailProductDisplayName;
              item2.productDetailCode = arr[index].productDetailCode;
            });
          }
        });
      },
      //第一个tab页表格行发生变化 改变第二个tab页表格的行
      changeTableRow(arr, arr2, basicUnit) {
        var data = this.extendList;
        if (arr2) {
          //删除
          this.extendList.forEach((item) => {
            for (var i = 0; i < item.list.length; i++) {
              arr2.forEach((row) => {
                item.list.splice(row.idx, 1);
              });
            }
          });
        } else {
          //新增
          data.map((item) => {
            let arrNew = JSON.parse(JSON.stringify(arr));
            arrNew[0].purchaseOrderUnitValue = 1;
            arrNew[0].salesOrderUnitValue = 1;
            arrNew[0].purchaseOrderUnit = basicUnit;
            arrNew[0].salesOrderUnit = basicUnit;
            item.list.unshift(arrNew[0]);
          });
          this.extendList = data;
        }
      },
      //修改数据权限表格数据
      changeAuth(arr) {
        let firstTabData = this.$refs.wchgData.exportChildData();
        let list = [];
        firstTabData.goodsTableData.map((item) => {
          let objChild = {
            productDetailCode: item.productDetailCode,
            detailProductDisplayName: item.detailProductDisplayName,
            costCourse: 'CBKM2',
            incomeCourse: 'SRKM1',
            purchaseOrderUnit: firstTabData.baseData.basicUnit,
            purchaseOrderUnitValue: 1,
            salesOrderUnit: firstTabData.baseData.basicUnit,
            salesOrderUnitValue: 1,
          };
          list.push(objChild);
        });
        var obj = {
          extendCompanyCode: arr[0].extendCompanyCode,
          extendCompanyName: arr[0].extendCompanyName,
          list: list,
        };
        this.extendList.unshift(obj);
      },
      //数据表格里面的公司变化
      changeCompany(value, name, index) {
        this.extendList[index].extendCompanyName = name;
        this.extendList[index].extendCompanyCode = value;
      },
      //点击进入修改页面
      modify: XEUtils.debounce(function () {
        console.log('11111');
        let path = {
          fromPath: {
            path: '/masterData/editGoods',
            name: 'editGoods',
            meta: {
              keepAlive: true,
              title: this.$t('goods.title.editGoods'),
            },
          },
          toPath: {
            path: '/masterData/goodsDetail',
            name: 'goodsDetail',
            meta: {
              keepAlive: true,
              title: this.$t('goods.title.goodsDetail'),
            },
            query: {
              propsGoodsId: this.goodsDetail.id,
              productDetailCode: this.$route.query.productDetailCode,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      }, 1000),
    },
  };
</script>

<style scoped>
  .addGoods {
    padding: 10px;
    margin-bottom: 80px;
    background-color: #fff;
  }
  /* 顶部按钮 */
  .addGoods .btn {
    text-align: left;
    padding: 20px 0px;
  }
  .addGoods .bottomBtn {
    text-align: center;
    padding: 20px;
  }
</style>
